<template>
  <v-card class="card-order-create-data">
    <v-card-title class="card-order-create-data__heading">Please, check all information again and confirm card order create</v-card-title>

    <scrollable-container>
      <data-row>
        <v-flex>
          <one-data-column>
            <data-label slot="label">User ID</data-label>
            <div class="t-create-user-id">{{ formData.userId }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Client</data-label>
            <div class="t-create-client font-weight-medium">{{ profile.name || profile.id }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Card type</data-label>
            <div class="t-create-type">{{ formData.cardType | cardType }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Card currency</data-label>
            <div class="t-create-currency">{{ formData.cardCurrency | cardType }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Card account</data-label>
            <div class="t-create-account">{{ formData.cardAccountId || 'New account' }}</div>
          </one-data-column>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Card holder</data-label>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Holder type</data-label>
            <div class="t-holder-type">{{ cardHolderType }}</div>
          </one-data-column>

          <one-data-column v-if="formData.holderBirthDate">
            <data-label slot="label">Holder date of birth</data-label>
            <div class="t-holder-birth-date">{{ formData.holderBirthDate }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Name on card</data-label>
            <div class="t-create-holder">{{ holderName }}</div>
          </one-data-column>

          <template v-if="profile.isLegal && isRealCardType">
            <one-data-column>
              <data-label slot="label">Company name</data-label>
              <div class="t-create-company">{{ formData.companyName }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Company name on card</data-label>
              <div class="t-create-name-on-card">{{ formData.nameOnCard | nameOnCard }}</div>
            </one-data-column>
          </template>

          <one-data-column>
            <data-label slot="label">Phone number</data-label>
            <div class="t-create-holder-phone">{{ formData.holderMobilePhone }}</div>
          </one-data-column>

          <one-data-column v-if="formData.holderEmail">
            <data-label slot="label">Email</data-label>
            <div class="t-create-holder-email">{{ formData.holderEmail }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Voice password</data-label>
            <div class="t-create-voice-password">{{ formData.voicePassword }}</div>
          </one-data-column>

          <template v-if="isRealCardType">
            <one-data-column :label-props="{ style: 'display: none;' }">
              <data-divider />
            </one-data-column>

            <one-data-column>
              <data-label
                slot="label"
                highlight
              >Delivery address</data-label>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Recipient</data-label>
              <div class="t-create-recipient">{{ recipientName }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Phone number</data-label>
              <div class="t-create-recipient-phone">{{ formData.recipientMobilePhone }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Country</data-label>
              <div class="t-create-country">{{ getCountryName(formData.addressCountry) }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">City</data-label>
              <div class="t-create-city">{{ formData.addressCity }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Street</data-label>
              <div class="t-create-street">{{ formData.addressStreet }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Postcode</data-label>
              <div class="t-create-postcode">{{ formData.addressZipCode }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Free delivery</data-label>
              <div class="t-create-free-delivery">{{ formData.disableDeliveryFee | booleanValue }}</div>
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Delivery type</data-label>
              <div class="t-create-delivery">{{ formData.shipmentType }}</div>
            </one-data-column>
          </template>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Expences</data-label>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Fee account</data-label>
            <div class="t-create-fee-account">{{ formData.feeAccountId }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Fee currency</data-label>
            <div class="t-create-fee-currency">{{ formData.feeCurrency }}</div>
          </one-data-column>

          <one-data-column v-if="isRealCardType">
            <data-label slot="label">Delivery fee</data-label>
            <div class="t-create-delivery-fee">{{ deliveryFee | number }} {{ formData.feeCurrency }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Card fee</data-label>
            <div class="t-create-card-fee">{{ issuingFee | number }} {{ formData.feeCurrency }}</div>
          </one-data-column>
        </v-flex>
      </data-row>
    </scrollable-container>

    <v-divider class="grey lighten-3" />
    <v-card-actions class="card-order-create-data__actions">
      <v-btn
        class="t-create-order"
        color="primary"
        flat="flat"
        :disabled="createCardOrderApiRequest.loading"
        @click="onConfirmButtonClick"
      >create card order</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        flat="flat"
        @click="closeModal"
      >cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { getCardHolderTypeLabel } from '@/utils/CardOrders'
  import { createCardOrderListRoute } from '@/utils/routing/Issuing'

  // Constants
  import { CARD_TYPES } from '@/models/CardOrder'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Events
  import { EVENT_CARD_ORDER_CREATE } from '@/events/cardOrders'

  // Mixins
  import countries from '@/mixins/countries'

  // Components
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import DataDivider from '@/components/ui/Data/DataDivider'

  export default {
    name: 'CardOrderCreateModal',
    components: {
      ScrollableContainer,
      DataRow,
      OneDataColumn,
      DataLabel,
      DataDivider
    },
    mixins: [countries],
    data () {
      return {
        createCardOrderApiRequest: new ApiRequest(
          IssuingApi.createCardOrder
        )
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profile () {
        return this.modal.data.profile
      },
      formData () {
        return this.modal.data.formData
      },
      deliveryFee () {
        return this.modal.data.deliveryFee
      },
      issuingFee () {
        return this.modal.data.issuingFee
      },
      holderName () {
        return `${this.formData.holderFirstName} ${this.formData.holderLastName}`
      },
      recipientName () {
        return `${this.formData.recipientFirstName} ${this.formData.recipientLastName}`
      },
      isRealCardType () {
        return this.formData.cardType === CARD_TYPES.REAL
      },
      cardHolderType () {
        return getCardHolderTypeLabel(this.profile.profileType, this.formData.holderType)
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.createCardOrder()
      },
      onCardOrderCreateSuccess () {
        this.showModal({
          name: 'SuccessFlashModal',
          data: {
            redirectPath: createCardOrderListRoute(),
            message: 'Card order has been successfully created.'
          }
        })
      },
      onCardOrderCreateError (error) {
        const systemError = error.findFirstSystemError()

        this.$eventHub.$emit(EVENT_CARD_ORDER_CREATE, error)

        this.showModal({
          name: 'ErrorFlashModal',
          data: {
            message: systemError != null ? systemError.message : 'Card order has not been created.'
          }
        })
      },
      createCardOrder () {
        this.createCardOrderApiRequest
          .execute(this.profile.id, this.formData)
          .then(this.onCardOrderCreateSuccess)
          .catch(this.onCardOrderCreateError)
      }
    }
  }
</script>

<style lang="scss">
  .card-order-create-data {
    font-size: 16px;
    font-weight: 400;

    &__heading,
    .container {
      padding-right: 30px;
      padding-left: 30px;
    }

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;
    }

    &__actions {
      padding: 14px 14px;
    }
  }
</style>
